import gql from 'graphql-tag';

export const SIGN_UP = gql`
    mutation signUp($signUpReq: SignUpReq!) {
        signUp(req: $signUpReq) {
            outcome
        }
    }
`;

export const UPDATE_CUSTOMER = gql`
    mutation updateCustomer($updateCustomerReq: UpdateCustomerReq!) {
      updateCustomer(req: $updateCustomerReq) {
        outcome
      }
    }
`;
export const ADMIN_SIGN_UP = gql`
  mutation adminSignUp($signUpReq: SignUpReq!) {
    adminSignUp(req: $signUpReq) {
      outcome
    }
  }
`;
